import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useServerFn } from '@tanstack/react-start';
import { TopicView } from '@/components/ki-texte/TopicView';
import { getStaffTopic } from '@/lib/ki-texte.functions';

export const Route = createFileRoute('/_admin/admin/ki-texte_/vorschau/$id')({
  head: () => ({ meta: [
    { title: 'KI-Text-Vorschau – creategy' }, { name: 'description', content: 'Geschützte Vorschau eines KI-Textes.' },
    { property: 'og:title', content: 'KI-Text-Vorschau – creategy' }, { property: 'og:description', content: 'Geschützte Vorschau eines KI-Textes.' },
    { property: 'og:type', content: 'website' }, { name: 'twitter:card', content: 'summary' }, { name: 'robots', content: 'noindex, nofollow' },
  ] }), component: TopicPreview,
});
function TopicPreview() {
  const { id } = Route.useParams(); const load = useServerFn(getStaffTopic);
  const { data, isPending, isError } = useQuery({ queryKey: ['ki-text-preview', id], queryFn: () => load({ data: { id } }) });
  if (isPending) return <p role="status" className="p-8">Vorschau wird geladen …</p>;
  if (isError || !data) return <p role="alert" className="p-8">Vorschau nicht verfügbar.</p>;
  return <TopicView topic={data} />;
}
